import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ForcePasswordReset from './ForcePasswordReset';

const DEMO_ALLOWED_PATHS = ['/curriculum', '/forum'];

const ProtectedRoute = ({ children, adminOnly = false, systemAdminOnly = false }) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#34657f] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[#5C5C5C]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // First-login: force temporary-password users to set their own password
  if (user?.must_reset_password) {
    return <ForcePasswordReset />;
  }

  // Demo accounts can only access Curriculum & Toolkit and Community Forum
  if (user?.role === 'demo') {
    const allowed = DEMO_ALLOWED_PATHS.some((p) => location.pathname.startsWith(p));
    if (!allowed) {
      return <Navigate to="/curriculum" replace />;
    }
  }

  // System-admin-only pages (Intern Progress, Scoring Rubric)
  if (systemAdminOnly && user?.role !== 'system_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // Admin-only pages
  if (adminOnly && user?.role !== 'system_admin' && user?.role !== 'team_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
